import React, { useState } from 'react';
import { confirmSignUp } from '@aws-amplify/auth';
import '../styles/global.css';

export default function ConfirmPage() {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');

  const handleConfirm = async (e) => {
    e.preventDefault();

    try {
      await confirmSignUp({ username: email, confirmationCode: code });
      setMessage('✅ Account confirmed! You can now log in.');
    } catch (error) {
      console.error('Confirmation error:', error);
      setMessage(error.message || 'Something went wrong.');
    }
  };

  return (
    <div className="container">
      <h1>Confirm Your Email</h1>
      {message && (
        <p style={{ color: message.startsWith('✅') ? 'green' : 'red' }}>{message}</p>
      )}

      <form onSubmit={handleConfirm} className="form-box">
        <label>
          Email:
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>

        <label>
          Confirmation Code:
          <input
            type="text"
            required
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
        </label>

        <button type="submit">Confirm Account</button>
      </form>
    </div>
  );
}
